import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import CheckList from '../molecules/CheckList';
import Reveal from '../atoms/Reveal';
import { ChatMockup, TrackingMockup } from '../molecules/Mockups';
import { acompanhamento, mensagemExemplo, whatsappSecao } from '../content/site';

/** O bloco escuro da página. É aqui que ela mostra a coisa mais concreta que o
 *  produto entrega — a mensagem pronta —, e o fundo roxo existe para separar
 *  isso do resto: quem só rolar a página até o fim vai parar neste bloco. */
function WhatsappSection() {
  return (
    <section className="section section--dark on-purple">
      <Container className="shell">
        <Row className="align-items-start g-4 gy-5">
          <Col lg={5}>
            <span className="section-kicker">{whatsappSecao.kicker}</span>
            <h2 className="section-title">{whatsappSecao.titulo}</h2>
            <p className="section-lead mb-4">{whatsappSecao.texto}</p>
            <CheckList items={whatsappSecao.notas} />
          </Col>

          {/* lg=7, não 6: as duas telas EMPILHADAS (celular estreito) já
              passavam de 1000px de altura contra uns 500px do texto ao lado —
              o mesmo problema do herói, só que pior, porque aqui nenhuma das
              duas tinha uma versão "compact" para encolher sem perder conteúdo
              de verdade. Lado a lado, a dupla usa a LARGURA que sobra em vez
              da altura que falta: a altura vira a da mais alta das duas, não a
              soma. `duo-art--row` só entra a partir do breakpoint em que as
              duas cabem sem apertar. */}
          <Col lg={7}>
            <div className="duo-art duo-art--row">
              <Reveal heavy>
                <ChatMockup mensagem={mensagemExemplo} />
              </Reveal>
              <Reveal heavy stagger={1}>
                <TrackingMockup dados={acompanhamento} />
              </Reveal>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WhatsappSection;
